import React from "react";
import "./header.css";
import { useSelector } from "react-redux";

const Header = () => {
  const reportInfo = useSelector((state) => state?.reportInfo)

  return (
    <>
      {/* Header */}
      <header className="title-page-header">
        <div className="title-page-header-left">
          <img src={reportInfo?.companyLogo || "companyLogo"} alt="logo" />
          {/* <h1>Max Green Energy</h1> */}
        </div>
        <div className="title-page-header-right">
          <h1>{reportInfo?.companyName || "companyName"}</h1>
        </div>
      </header>
      {/* Divider Line */}
      <div className="divider-line" />
    </>
  );
};

export default Header;
